export enum UserRole {
  PRACTITIONER = 'practitioner',
  VERIFIER = 'verifier',
  ADMIN = 'admin',
}

export enum Permission {
  MANAGE_USERS = 'manage_users',
  ACCESS_PROJECTS = 'access_projects',
  VIEW_PROJECTS_LIST = 'view_projects_list',
  VIEW_ALL_PROJECTS = 'view_all_projects',
  ACCESS_VERIFIER_POOL = 'access_verifier_pool',
}

export const RolePermissions: Record<UserRole, Permission[]> = {
  [UserRole.ADMIN]: [
    Permission.MANAGE_USERS,
    Permission.ACCESS_PROJECTS,
    Permission.ACCESS_VERIFIER_POOL,
    Permission.VIEW_ALL_PROJECTS,
  ],
  [UserRole.PRACTITIONER]: [
    Permission.ACCESS_PROJECTS,
    Permission.VIEW_PROJECTS_LIST,
  ],
  [UserRole.VERIFIER]: [
    Permission.ACCESS_PROJECTS,
    Permission.ACCESS_VERIFIER_POOL,
  ],
};

export enum ProjectRole {
    EDITOR = 'editor',
    VERIFIER_REVIEWER = 'verifier_reviewer',
  }
  
  export enum ProjectPermission {
    // Viewing permissions
    VIEW_PROJECT = 'view_project',
    VIEW_PROJECT_DOCUMENTS = 'view_project_documents',
    VIEW_COMMENTS = 'view_comments',
    VIEW_AUDIT_LOGS = 'view_audit_logs',

    // Editing permissions
    EDIT_PROJECT = 'edit_project',
    ADD_DOCUMENTS = 'add_documents',
    REMOVE_DOCUMENTS = 'remove_documents',
    ADD_COMMENTS = 'add_comments',
    EDIT_COMMENTS = 'edit_comments',
    DELETE_COMMENTS = 'delete_comments',
    CREATE_VALIDATION_EXCEPTION = 'create_validation_exception',
    EDIT_VALIDATION_EXCEPTION = 'edit_validation_exception',
    DELETE_VALIDATION_EXCEPTION = 'delete_validation_exception',

    // Admin permissions
    MANAGE_ACCESS = 'manage_access',
    DELETE_PROJECT = 'delete_project',
    RERUN_VALIDATION = 'rerun_validation',
    STOP_VALIDATION = 'stop_validation',

    // Verifier permissions
    SUBMIT_VERDICT = 'submit_verdict',
    REVIEW_VALIDATION_EXCEPTION = 'review_validation_exception',
  }
  

export const ProjectRolePermissions: Record<ProjectRole, ProjectPermission[]> = {
  [ProjectRole.EDITOR]: [
    ProjectPermission.ADD_COMMENTS,
    ProjectPermission.ADD_DOCUMENTS,
    ProjectPermission.DELETE_COMMENTS,
    ProjectPermission.DELETE_PROJECT,
    ProjectPermission.EDIT_COMMENTS,
    ProjectPermission.EDIT_PROJECT,
    ProjectPermission.MANAGE_ACCESS,
    ProjectPermission.REMOVE_DOCUMENTS,
    ProjectPermission.RERUN_VALIDATION,
    ProjectPermission.STOP_VALIDATION,
    ProjectPermission.VIEW_COMMENTS,
    ProjectPermission.VIEW_PROJECT_DOCUMENTS,
    ProjectPermission.VIEW_PROJECT,
    ProjectPermission.VIEW_AUDIT_LOGS,
    ProjectPermission.CREATE_VALIDATION_EXCEPTION,
    ProjectPermission.EDIT_VALIDATION_EXCEPTION,
    ProjectPermission.DELETE_VALIDATION_EXCEPTION,
  ],
  [ProjectRole.VERIFIER_REVIEWER]: [
    ProjectPermission.VIEW_PROJECT,
    ProjectPermission.VIEW_PROJECT_DOCUMENTS,
    ProjectPermission.VIEW_COMMENTS,
    ProjectPermission.ADD_COMMENTS,
    ProjectPermission.EDIT_COMMENTS,
    ProjectPermission.SUBMIT_VERDICT,
    ProjectPermission.REVIEW_VALIDATION_EXCEPTION,
  ],
};

export const AdminProjectPermissions: ProjectPermission[] = [
  ProjectPermission.VIEW_PROJECT,
  ProjectPermission.VIEW_PROJECT_DOCUMENTS,
  ProjectPermission.VIEW_COMMENTS,
  ProjectPermission.EDIT_PROJECT,
  ProjectPermission.ADD_DOCUMENTS,
  ProjectPermission.REMOVE_DOCUMENTS,
  ProjectPermission.ADD_COMMENTS,
  ProjectPermission.EDIT_COMMENTS,
  ProjectPermission.DELETE_COMMENTS,
  ProjectPermission.CREATE_VALIDATION_EXCEPTION,
  ProjectPermission.EDIT_VALIDATION_EXCEPTION,
  ProjectPermission.DELETE_VALIDATION_EXCEPTION,
  ProjectPermission.MANAGE_ACCESS,
  ProjectPermission.DELETE_PROJECT,
  ProjectPermission.RERUN_VALIDATION,
  ProjectPermission.STOP_VALIDATION,
  ProjectPermission.VIEW_AUDIT_LOGS,
];
